import axiosInstance from "@js-app/services/http/axios-instance";

class InvoicesApi {
	getInvoices(params = {}) {
		return axiosInstance.get("/invoices", {
			params,
			withCredentials: true,
		});
	}

	getInvoice(id, partnerUUID, partnerToken) {
		return axiosInstance.get('/invoices/' + id, {
			headers: {
				partnerUuid: partnerUUID,
				partnerToken: partnerToken
			},
		})
	}

	getStats(params = {}) {
		return axiosInstance.get("/invoices/stats", {
			params,
			withCredentials: true,
		});
	}

	createInvoice(payload) {
		return axiosInstance.post(
			"/invoices",
			payload,
			{ withCredentials: true }
		);
	}

	updateInvoice(id, payload) {
		return axiosInstance.put(
			`/invoices/${id}`,
			payload,
			{ withCredentials: true }
		);
	}

	cancelInvoice(id, partnerUUID, partnerToken) {
		return axiosInstance.post(`/invoices/${id}/cancel`, {
			sender: {
				partner_uuid: partnerUUID,
				partner_token: partnerToken
			},
		});
	}

	bulkCancelInvoices(ids = [], partnerUUID, partnerToken) {
		return axiosInstance.post(
			`/invoices/bulk-cancel`,
			{
				ids,
				sender: {
					partner_uuid: partnerUUID,
					partner_token: partnerToken,
				},
			},
			{ withCredentials: true }
		);
	}

	deleteInvoice(id, partnerUUID, partnerToken) {
		return axiosInstance.delete(`/invoices/${id}`, {
			headers: {
				partnerUuid: partnerUUID,
				partnerToken: partnerToken
			},
		});
	}

	refundInvoice(id, payload) {
		return axiosInstance.post(
			`/invoices/${id}/refund`,
			payload,
			{ withCredentials: true }
		)
	}
}

export const invoicesApi = new InvoicesApi();
